import { restGet, restPost } from "../api.services";

const BASE_PATH = "/moksha-reservations";

export const reservationsApi = {
    // A refusal carries the server's message; a network failure has none, so message stays "".
    getAvailability: async (query) => {
        const apiResponse = await restGet(`${BASE_PATH}/availability`, query, { silentErrors: true });
        if (apiResponse?.data?.customStatus) return { ok: true, data: apiResponse.data.data };
        const message = apiResponse?.data?.message;
        return { ok: false, message: typeof message === "string" ? message : "" };
    },
    createReservation: async (body) => {
        const apiResponse = await restPost(BASE_PATH, body, { silentErrors: true });
        if (apiResponse?.data?.customStatus) return { ok: true, data: apiResponse.data.data };
        return {
            ok: false,
            message: apiResponse?.data?.message || "The reservation was not saved.",
            conflicts: apiResponse?.data?.data?.conflicts || [],
        };
    },
};
